import React from 'react';
import { InputText } from 'primereact/inputtext';
import Label from '../Label';
import { classNames } from 'primereact/utils';

const FormikTextField = (props) => {
  const {
    labelText,
    isMandatory = false,
    formik,
    name,
    placeholder,
    className,
    onChange,
    onBlur,
    ...rest
  } = props;

  const isInvalid = !!(formik.touched[name] && formik.errors[name]);
  const mergeClassName = classNames(className, {
    'p-invalid': isInvalid
  });
  return (
    <>
      {labelText && <Label htmlFor={name} text={labelText} isMandatory={isMandatory} />}
      <InputText
        {...rest}
        id={name}
        name={name}
        placeholder={placeholder}
        value={formik.values[name]}
        onChange={onChange || formik.handleChange}
        onBlur={onBlur || formik.handleBlur}
        className={mergeClassName}
      />
      {isInvalid && <small className="p-error">{formik.errors[name]}</small>}
    </>
  );
};

export default FormikTextField;
